import React, {Fragment, useRef, useState, useEffect} from "react";
import SnackbarUtil from '@/utils/SnackbarUtil';
import {useTranslation} from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Box,
  Switch,
  FormControlLabel,
  IconButton,
  TextField,
  MenuItem,
  Select,
  Link,
  Checkbox,
  Fab,
} from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import UserService from '@/services/auth/UserService'
import CloseIcon from "@mui/icons-material/Close";
import Divider from '@mui/material/Divider';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ComplianceConfirm = () => {
  const [info, setInfo] = useState<boolean>(false)
  const [previewOpen, setPreviewOpen] = useState<boolean>(false)
  const [showCloseButton, setShowCloseButton] = useState<boolean>(false)
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const {t} = useTranslation()
  const [loading, setLoading] = React.useState(false);
  const [bioCollection, setBioCollection] = React.useState(false);
  const [firstCompliance, setFirstCompliance] = React.useState(false);
  const [confirm1, setConfirm1] = useState(false);
  const [confirm2, setConfirm2] = useState(false);
  const [initials, setInitials] = useState('');
  const [cycle, setCycle] = useState('30');
  const [agreeTerm, setAgreeTerm] = useState(false);
  const [pdfUpdate, setPdfUpdate] = useState(false);
  const [adminName, setAdminName] = useState('');
  const [confirmDate, setConfirmDate] = useState('');
  const [adminFile, setAdminFile] = useState('https://ngteco-office-prod.s3.us-east-1.amazonaws.com/market/en/NGTECO+Biometric+Privacy+Policy.pdf');
  const [empFile, setEmpFile] = useState('https://ngteco-office-prod.s3.us-east-1.amazonaws.com/market/en/NGTECO+Employee+Biometric+Consent.pdf');

  const complianceConfirm = (type: any) => {
    if (type == 'confirm') {
      if (!agreeTerm) {
        SnackbarUtil.error(t("common.Check the box 'I agree to and accept this agreement' to continue."), {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
          }
        })
        return
      } else if (!confirm1 || !confirm2) {
        SnackbarUtil.error(t("common.Please read the Biometric Privacy Policy in its entirety first."), {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
          }
        })
        return
      } else if (!adminName || !initials) {
        SnackbarUtil.error(t("common.Your initials or Administrator Name is required."), {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
          }
        })
        return
      }
      if (initials.length > 5) {
        SnackbarUtil.error(t("common.The length of this field cannot exceed digits", {field_name: "Initials", number: 5}), {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
          }
        })
        return
      }
      if (adminName.length > 50) {
        SnackbarUtil.error(t("common.The length of this field cannot exceed digits", {field_name: "Administrator Name", number: 50}), {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center'
          }
        })
        return
      }
      setLoading(true)
      const data = {
        "compliance_cycle": cycle,
        "admin_name": adminName,
        "initials": initials
      }
      UserService.compliance_operation(data, 'POST').then(
        (result) => {
          if (type == 'confirm') {
            SnackbarUtil.success(t("common.Company Compliance save successfully."),
              {anchorOrigin: {vertical: 'top', horizontal: 'center'}})
          }
          setBioCollection(true)
        }
      )
      window.location.reload()
    } else {
      if (firstCompliance || pdfUpdate) {
        UserService.compliance_operation({}, 'POST').then(
          (result) => {
            if (type == 'cancel') {
              // SnackbarUtil.success(t("common.Company Compliance save successfully."),
              //   {anchorOrigin: {vertical: 'top', horizontal: 'center'}})
            }
          }
        )
      }
    }
    setInfo(false)
    setFirstCompliance(false)
    setPdfUpdate(false)
    setLoading(false)
  }

  useEffect(() => {
    UserService.compliance_operation({}, 'GET').then(
      (result) => {
        setBioCollection(result.data?.company_compliance?.bio_collection || false)
        setFirstCompliance(result.data?.company_compliance?.first_compliance || false)
        if (result.data?.company_compliance?.bio_collection) {
          setConfirm1(true)
          setConfirm2(true)
          setAgreeTerm(true)
          setConfirmDate(result.data?.company_compliance?.confirm_date)
          setAdminName(result.data?.company_compliance?.admin_name)
          setCycle(result.data?.company_compliance?.compliance_cycle)
          setInitials(result.data?.company_compliance?.initials)
        }
        setAdminFile(result.data?.admin_pdf)
        setEmpFile(result.data?.employee_pdf)
        setPdfUpdate(result.data?.pdf_update)
      }
    )
  }, [])
  useEffect(() => {
    if (bioCollection && info) {
      UserService.compliance_operation({}, 'GET').then(
        (result) => {
          setBioCollection(result.data?.company_compliance?.bio_collection || false)
          setFirstCompliance(result.data?.company_compliance?.first_compliance || false)
        }
      )
    }
  }, [info])

  const handleDownloadEmployee = () => {
    try {
      const link = document.createElement('a');
      link.href = empFile;
      link.download = 'Employee+Biometric+Consent.pdf';
      link.target = '_blank';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('download error:', error);
    }
  };
  const handleDownload = () => {
    try {
      const link = document.createElement('a');
      link.href = adminFile;
      link.target = '_blank';
      link.download = 'Biometric+Privacy+Policy.pdf';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('download error:', error);
    }
  };

  // 新增：处理iframe加载和滚动事件
  const handleIframeLoad = () => {
    if (iframeRef.current) {
      const iframe = iframeRef.current;

      try {
        // 尝试访问iframe内部文档
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

        if (iframeDoc) {
          // 添加滚动事件监听
          iframeDoc.addEventListener('scroll', () => {
            const scrollTop = iframeDoc.documentElement.scrollTop || iframeDoc.body.scrollTop;
            const scrollHeight = iframeDoc.documentElement.scrollHeight || iframeDoc.body.scrollHeight;
            const clientHeight = iframeDoc.documentElement.clientHeight || iframeDoc.body.clientHeight;

            // 判断是否滚动到底部（留出50px的缓冲区域）
            const isBottom = scrollHeight - scrollTop - clientHeight <= 10;

            if (isBottom && !showCloseButton) {
              setShowCloseButton(true);
            } else if (!isBottom && showCloseButton) {
              setShowCloseButton(false);
            }
          });
        }
      } catch (error) {
        console.error('无法访问iframe内容:', error);
        // 备用方案：使用setTimeout在加载后检查滚动
        setTimeout(() => {
          if (iframeRef.current) {
            const iframe = iframeRef.current;
            iframe.addEventListener('load', () => {
              // 给iframe添加一次性滚动检查
              const checkScroll = () => {
                try {
                  const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
                  if (iframeDoc) {
                    const scrollHeight = iframeDoc.documentElement.scrollHeight || iframeDoc.body.scrollHeight;
                    const clientHeight = iframeDoc.documentElement.clientHeight || iframeDoc.body.clientHeight;

                    // 如果文档高度小于或等于iframe高度，认为已经到底部
                    if (scrollHeight <= clientHeight + 100) {
                      setShowCloseButton(true);
                    }
                  }
                } catch (e) {
                  console.error('滚动检查失败:', e);
                }
              };

              // 延迟检查，确保内容已加载
              setTimeout(checkScroll, 1000);
            });
          }
        }, 1000);
      }
    }
  };

  // 新增：手动检查滚动位置的函数
  const checkIframeScroll = () => {
    if (iframeRef.current) {
      try {
        const iframe = iframeRef.current;
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

        if (iframeDoc) {
          const scrollTop = iframeDoc.documentElement.scrollTop || iframeDoc.body.scrollTop;
          const scrollHeight = iframeDoc.documentElement.scrollHeight || iframeDoc.body.scrollHeight;
          const clientHeight = iframeDoc.documentElement.clientHeight || iframeDoc.body.clientHeight;

          // 判断是否滚动到底部
          const isBottom = scrollHeight - scrollTop - clientHeight <= 50;

          if (isBottom && !showCloseButton) {
            setShowCloseButton(true);
          }
        }
      } catch (error) {
        console.error('检查滚动位置失败:', error);
      }
    }
  };

  // 新增：滚动到iframe底部的函数
  const scrollToBottom = () => {
    if (iframeRef.current) {
      try {
        const iframe = iframeRef.current;
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

        if (iframeDoc) {
          const scrollHeight = iframeDoc.documentElement.scrollHeight || iframeDoc.body.scrollHeight;
          const clientHeight = iframeDoc.documentElement.clientHeight || iframeDoc.body.clientHeight;

          // 滚动到底部
          iframeDoc.documentElement.scrollTop = scrollHeight - clientHeight;
          iframeDoc.body.scrollTop = scrollHeight - clientHeight;

          // 触发滚动事件
          setTimeout(() => {
            const scrollEvent = new Event('scroll');
            iframeDoc.dispatchEvent(scrollEvent);
          }, 100);
        }
      } catch (error) {
        console.error('滚动到底部失败:', error);
      }
    }
  };

  return (
    <Fragment>
      <Grid item={true}>
        <FormControlLabel
          labelPlacement="end"
          label={t("common.Biometric collection")}
          sx={{color: "rgb(117, 130, 138)", fontSize: "14px !important"}}
          control={<Switch color="primary"
                           checked={bioCollection}
                           onChange={() => setInfo(true)}/>}
        />
      </Grid>
      <Dialog
        open={pdfUpdate || firstCompliance || info}
        onClose={() => {
          setInfo(false);
        }}
        sx={{
          '& .MuiDialog-paper': {
            width: '80%',
            maxWidth: '1200px',
            padding: 2
          }
        }}
      >
        <DialogTitle
          sx={{
            position: 'static',
            left: '24px',
            top: '20px',
            fontSize: '16px',
            color: '#999999',
            fontWeight: 'normal'
          }}>
          {t("common.Biometric Data Disclosure and Authorization")}
          {(!(pdfUpdate || firstCompliance)) && <IconButton
            aria-label="close"
            onClick={() => setInfo(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon/>
          </IconButton>}
        </DialogTitle>
        <Divider/>

        <DialogContent sx={{lineHeight: '25px', color: 'gray', mt: 2}}>
          <Typography variant="body1" sx={{color: "#666666", mb: 3, fontWeight: 'normal', fontSize: '16px'}}>
            {t('common.Company Compliance Content1')}
          </Typography>

          <Box sx={{mb: 4, position: 'relative', pl: 6}}>
            <Box sx={{
              position: 'absolute',
              left: 2,
              top: 2,
              width: 20,
              height: 20,
              opacity: 1,
              background: '#2BA9DE',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontSize: 12,
              fontWeight: 'bold'
            }}>
              1
            </Box>
            <Typography
              variant="body1"
              sx={{
                color: "#333333",
                fontWeight: 'bold',
                fontSize: '16px',
                letterSpacing: '0em'
              }}
            >
              {t('common.Company Compliance Content2')}
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={confirm1}
                  onChange={(e) => setConfirm1(e.target.checked)}
                  color="primary"
                  disabled={bioCollection}
                />
              }
              sx={{color: "#666666", fontSize: "10px", fontWeight: 'normal'}}
              label={t('common.Company Compliance Content3')}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={confirm2}
                  onChange={(e) => setConfirm2(e.target.checked)}
                  color="primary"
                  disabled={bioCollection}
                />
              }
              sx={{color: "#666666", fontSize: "10px", fontWeight: 'normal'}}
              label={t('common.Company Compliance Content4')}
            />

            <Box
              sx={{
                mt: 2,
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                gap: 2
              }}
            >
              <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                <Typography
                  sx={{color: "#666666", fontSize: "14px", fontWeight: 'normal'}}
                >
                  {t('common.Company Compliance Content5')}
                </Typography>
                <TextField
                  value={initials}
                  onChange={(e) => setInitials(e.target.value)}
                  sx={{width: '150px'}}
                  size="small"
                  disabled={bioCollection}
                  variant="standard"
                />
              </Box>

              <Box sx={{flexGrow: 1, display: 'flex', justifyContent: 'flex-end', marginRight: '10px'}}>
                <IconButton sx={{"&:hover": {backgroundColor: "transparent"}}}
                            onClick={() => handleDownloadEmployee()}>
                  <i className="icon iconfont icon-ic_download"
                     style={{cursor: 'pointer', color: '#8F9CA3'}}></i>
                  <span style={{
                    fontSize: '12px',
                    color: '#75828A',
                    cursor: "pointer",
                    marginLeft: '4px',
                    marginTop: '-2px',
                    display: 'inline-block',
                    verticalAlign: 'middle'
                  }}>{t("common.Download")}</span>
                </IconButton>
              </Box>
            </Box>
          </Box>

          <Box sx={{mb: 4, position: 'relative', pl: 6}}>
            <Box sx={{
              position: 'absolute',
              left: 2,
              top: 2,
              width: 20,
              height: 20,
              opacity: 1,
              background: '#2BA9DE',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontSize: 12,
              fontWeight: 'bold'
            }}>
              2
            </Box>
            <Typography variant="body1" sx={{color: "#333333", fontWeight: 'bold', fontSize: "14px"}}>
              {t('common.Company Compliance Content6')}
            </Typography>

            <Box sx={{marginTop: '16px'}}>
              <Typography sx={{color: "#666666", fontWeight: 'normal', fontSize: "14px"}}>
                {t('common.Company Compliance Content7')}</Typography>
            </Box>
            <Box sx={{marginTop: '10px'}}>
              <Select
                value={cycle}
                disabled={bioCollection}
                onChange={(e) => setCycle(e.target.value)}
                sx={{width: '400px', height: '40px'}}
                size="small"
              >
                <MenuItem value="30">{t("common.30 Days")}</MenuItem>
                <MenuItem value="90">{t("common.90 Days")}</MenuItem>
                <MenuItem value="365">{t("common.365 Days")}</MenuItem>
              </Select>
            </Box>
          </Box>

          <Box sx={{mb: 4, position: 'relative', pl: 6}}>
            <Box sx={{
              position: 'absolute',
              left: 2,
              top: 2,
              width: 20,
              height: 20,
              opacity: 1,
              background: '#2BA9DE',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontSize: 12,
              fontWeight: 'bold'
            }}>
              3
            </Box>
            <Typography variant="body1" sx={{color: "#333333", fontWeight: 'bold', fontSize: '14px'}}>
              {t('common.Company Compliance Content8')}
            </Typography>

            {/* 修改：改为按钮打开预览弹窗 */}
            <Box sx={{mt: 2, display: 'flex', justifyContent: 'flex-start'}}>
              <Button
                variant="outlined"
                onClick={() => {
                  setPreviewOpen(true);
                  setShowCloseButton(false); // 重置关闭按钮状态
                }}
                startIcon={<i className="icon iconfont icon-eye"></i>}
                sx={{
                  textTransform: 'capitalize',
                  borderColor: '#2BA9DE',
                  color: '#2BA9DE',
                  '&:hover': {
                    borderColor: '#2BA9DE',
                    backgroundColor: 'rgba(43, 169, 222, 0.04)'
                  }
                }}
              >
                {t("common.Preview Document")}
              </Button>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              mt: 1
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={agreeTerm}
                  onChange={(e) => setAgreeTerm(e.target.checked)}
                  disabled={bioCollection}
                  color="primary"
                />
              }
              label={t('common.Company Compliance Content9')}
              sx={{color: '#3D3D3D', fontSize: '14px', fontWeight: 'normal'}}
            />

            <IconButton
              sx={{
                "&:hover": {backgroundColor: "transparent"},
                padding: 0,
                position: 'relative',
                ml: 2,
                marginRight: '10px'
              }}
              onClick={() => handleDownload()}
            >
              <i className="icon iconfont icon-ic_download"
                 style={{
                   cursor: 'pointer',
                   color: '#8F9CA3',
                   verticalAlign: 'middle'
                 }}
              ></i>
              <span style={{
                fontSize: '12px',
                color: '#75828A',
                cursor: "pointer",
                marginLeft: '4px',
                textTransform: 'capitalize',
                display: 'inline-block',
                verticalAlign: 'middle'
              }}>
                {t("common.Download")}
              </span>
            </IconButton>
          </Box>
          <Divider/>
          <Box
            sx={{
              mt: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              gap: 2
            }}
          >
            <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
              <Typography variant="body2" sx={{color: '#333333', fontSize: '12px', fontWeight: 'normal'}}>
                {t('common.Administrator Name')}
              </Typography>
              <TextField
                value={adminName}
                disabled={bioCollection}
                onChange={(e) => setAdminName(e.target.value)}
                sx={{width: '200px'}}
                size="small"
                variant="standard"
              />
            </Box>

            {bioCollection && (
              <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                <Typography variant="body2" sx={{color: '#333333', fontSize: '12px', fontWeight: 'normal'}}>
                  {t('common.Date of Signature')}
                </Typography>
                <Typography variant="body2" sx={{color: '#75828A', fontSize: '12px', fontWeight: 'normal'}}>
                  {confirmDate}
                </Typography>
              </Box>
            )}
          </Box>
          {!bioCollection && <DialogActions>
            <Button id='CancelButton' sx={{textTransform: "capitalize"}}
                    onClick={() => (complianceConfirm('cancel'))}>{t('common.cancel')}</Button>
            <LoadingButton
              id='ConfirmButton'
              loading={loading}
              sx={{textTransform: "capitalize"}}
              onClick={() => (complianceConfirm('confirm'))}
              variant={"contained"}>{t('common.save')}</LoadingButton>
          </DialogActions>}
        </DialogContent>
      </Dialog>
      <Dialog
        open={previewOpen}
        onClose={() => {
          setPreviewOpen(false);
          setShowCloseButton(false);
        }}
        maxWidth="lg"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            width: '90%',
            maxWidth: '1000px',
            height: '90vh',
            position: 'relative'
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 24px',
            backgroundColor: "transparent",
            borderBottom: '1px solid #e0e0e0'
          }}
        >
          <Typography variant="h6" sx={{fontWeight: 'bold'}}>
            {t("common.Biometric Privacy Policy - Preview")}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => {
              setPreviewOpen(false);
              setShowCloseButton(false);
            }}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{padding: 0, position: 'relative'}}>
          {/* 文档预览区域 */}
          <Box sx={{width: '100%', height: '100%', position: 'relative'}}>
            <iframe
              ref={iframeRef}
              src={adminFile}

              width="100%"
              height="100%"
              frameBorder="0"
              title={t("common.Legal Terms Preview")}
              onLoad={handleIframeLoad}
              style={{border: 'none'}}
            />

            {/* 滚动到底部提示 */}
            {!showCloseButton && (
              <Fab
                color="primary"
                size="small"
                onClick={scrollToBottom}
                sx={{
                  position: 'absolute',
                  bottom: 80,
                  right: 20,
                  backgroundColor: '#2BA9DE',
                  '&:hover': {
                    backgroundColor: '#1a8bc1'
                  }
                }}
              >
                <KeyboardArrowDownIcon/>
              </Fab>
            )}
          </Box>

          {/* 底部操作栏 - 只在滚动到底部时显示 */}
          {showCloseButton && (
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                padding: '16px 24px',
                borderTop: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: 2,
                zIndex: 1000
              }}
            >
              <Typography variant="body2" sx={{color: '#4CAF50', fontWeight: 'bold'}}>
                ✓ {t("common.You have reached the end of the document")}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setPreviewOpen(false);
                  setShowCloseButton(false);
                }}
                sx={{
                  backgroundColor: '#2BA9DE',
                  '&:hover': {
                    backgroundColor: '#1a8bc1'
                  }
                }}
              >
                {t("common.Close Preview")}
              </Button>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Fragment>
  )
}

export default ComplianceConfirm;
